import { ScaledSize } from 'react-native';
import { theme } from 'src/themes/light';

const {
  breakpoints: { phone, tablet, desktop },
} = theme;

export const isMobile = ({ width }: ScaledSize) => width <= tablet;
export const isTablet = ({ width }: ScaledSize) => width > phone && width < desktop;
export const isDesktop = ({ width }: ScaledSize) => width >= desktop;
